export const environment = {
  production: false,
  developementMode:false,
  url: 'https://form.people.test.private.unico.run/svc2',
  url_api_routing: 'https://admin.people.test.private.unico.run/api/routing/v1',
  identity_url: 'https://identityqa.acesso.io',
  base_url: 'https://form.benefits.people.test.private.unico.run',
  admission_url: 'https://form.people.test.private.unico.run',
  cdn_url: 'https://form.people.test.private.unico.run/cdn2',
  svc1_url: 'https://test-form.acessorh.com.br/svc2',
  segment_key: 'aJSx6ITwDTBcFEq6je022Y0UrC52Khm1',
  redirect_uri: 'https://form.benefits.people.test.private.unico.run/callback',
  sentry_key: 'N/A',
  maps_key: 'QUl6YVN5QUJSdlk2V0NUQ2pmajYwV3pFdUMxSjdZb3B4eElla1Jv',
  launchDarklyClientId: '63b870113b5a4212abb0f0fa',
  mixpanel_token: 'f4069d9b550ea08e34089810c2abd5be',
};
